module.exports = __webpack_public_path__ + "img/buddy_head.8b3edd77.svg";